/**
 * Formatadores de dados para exibição
 * 
 * Single Responsibility: Apenas formatação de dados
 * DRY: Centraliza formatações usadas em múltiplos componentes
 */

export const formatPrice = (price) => {
  if (!price) return 'A definir'
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(price)
}

export const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })
}

export const formatFullDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' })
}

export const formatPassengers = (adults = 1, children = 0, infants = 0) => {
  const parts = []
  
  if (adults === 1) parts.push('1 adulto')
  else if (adults > 1) parts.push(`${adults} adultos`)

  if (children === 1) parts.push('1 criança')
  else if (children > 1) parts.push(`${children} crianças`)

  if (infants === 1) parts.push('1 bebê')
  else if (infants > 1) parts.push(`${infants} bebês`)

  return parts.join(', ') || '1 adulto'
}

export const getBlockIcon = (type) => {
  const icons = {
    flight: '✈️',
    hotel: '🏨',
    transfer: '🚗',
    tour: '🎯',
    car: '🚙'
  }
  return icons[type] || '📦'
}
